import Vue from 'vue'

export default Vue.extend({
  template: `
    <div class='p-3 bg-dark-subtle border-left border-info' style="font-size: 0.85rem;" @contextmenu.prevent="onContextMenu">
      <b-row no-gutters v-if="match && match.user && match.opponent">
        <!-- User Team -->
        <b-col md="6" class="pr-3 border-right border-secondary">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-primary font-weight-bold" style="font-size: 0.9rem">
                <i class="fa fa-user mr-1"></i> {{ match.user.name }}
            </span>
            <b-badge :variant="match.user.ratingChange > 0 ? 'success' : 'danger'" v-if="match.user.ratingChange !== 0" size="sm" class="px-2">
                {{ match.user.ratingChange > 0 ? '+' : '' }}{{ match.user.ratingChange }}
            </b-badge>
          </div>
          
          <div v-for="poke in (match.user.pokemon ? Object.values(match.user.pokemon) : [])" :key="poke.ID" 
               class="mb-2 p-2 rounded border shadow-sm transition-all"
               :style="getCardStyle(poke)">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <span class="font-weight-bold" :class="getHPPercent(poke) === 0 ? 'text-danger text-decoration-line-through' : 'text-white'" style="font-size: 0.9rem">
                    {{ poke.name }}
                </span>
                <span class="text-muted small ml-2">Lvl {{ poke.level }}</span>
                <small v-if="poke.heldItem" class="text-info ml-2"><i class="fa fa-briefcase mr-1"></i>{{ poke.heldItem }}</small>
              </div>
              <div class="text-right small line-height-1">
                <span class="text-muted mr-3">{{ poke.ability }}</span>
                <span class="text-warning font-italic">{{ poke.nature }}</span>
              </div>
            </div>

            <!-- HP Visual -->
            <div class="d-flex align-items-center mt-2 mb-1" style="height: 14px">
                <small class="text-muted mr-2 font-weight-bold" style="font-size: 0.65rem; min-width: 25px">
                    <i class="fa fa-heart text-danger mr-1"></i>HP
                </small>
                <div class="progress flex-grow-1 mr-3" style="height: 5px; background-color: rgba(0,0,0,0.5); border-radius: 3px; overflow: hidden">
                    <div class="progress-bar transition-all" role="progressbar" 
                         :style="getHPBarStyle(poke)" 
                         :aria-valuenow="getHPPercent(poke)" aria-valuemin="0" aria-valuemax="100">
                    </div>
                </div>
                <small :style="{color: getHPColor(poke)}" class="font-weight-bold" style="font-size: 0.7rem; min-width: 32px; text-align: right">
                    {{ getHPPercent(poke) }}%
                </small>
            </div>

            <div class="mt-1 d-flex justify-content-between align-items-center pt-1 border-top border-dark-subtle">
              <div class="d-flex flex-wrap">
                <span v-for="(skill, index) in poke.skills" :key="index" class="badge badge-outline-secondary mr-1 mb-0 px-2 border border-secondary text-light opacity-75" style="font-size: 0.7rem; background: rgba(0,0,0,0.2)">
                  {{ skill }}
                </span>
              </div>
              <small class="text-muted font-italic opacity-50" v-if="poke.ID" style="font-size: 0.65rem">ID: {{ poke.ID }}</small>
            </div>
          </div>
        </b-col>

        <!-- Opponent Team -->
        <b-col md="6" class="pl-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-danger font-weight-bold" style="font-size: 0.9rem">
                <i class="fa fa-crosshairs mr-1"></i> {{ match.opponent.name }}
            </span>
            <b-badge :variant="match.opponent.ratingChange > 0 ? 'success' : 'danger'" v-if="match.opponent.ratingChange !== 0" size="sm" class="px-2">
                {{ match.opponent.ratingChange > 0 ? '+' : '' }}{{ match.opponent.ratingChange }}
            </b-badge>
          </div>

          <div v-for="poke in (match.opponent.pokemon ? Object.values(match.opponent.pokemon) : [])" :key="poke.ID" 
               class="mb-2 p-2 rounded border shadow-sm transition-all"
               :style="getCardStyle(poke)">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <span class="font-weight-bold" :class="getHPPercent(poke) === 0 ? 'text-danger text-decoration-line-through' : 'text-white'" style="font-size: 0.9rem">
                    {{ poke.name }}
                </span>
                <span class="text-muted small ml-2">Lvl {{ poke.level }}</span>
                <small v-if="poke.heldItem" class="text-info ml-2"><i class="fa fa-briefcase mr-1"></i>{{ poke.heldItem }}</small>
              </div>
              <div class="text-right small line-height-1">
                <span class="text-muted mr-3">{{ poke.ability }}</span>
                <span class="text-warning font-italic">{{ poke.nature }}</span>
              </div>
            </div>

            <!-- HP Visual -->
            <div class="d-flex align-items-center mt-2 mb-1" style="height: 14px">
                <small class="text-muted mr-2 font-weight-bold" style="font-size: 0.65rem; min-width: 25px">
                    <i class="fa fa-heart text-danger mr-1"></i>HP
                </small>
                <div class="progress flex-grow-1 mr-3" style="height: 5px; background-color: rgba(0,0,0,0.5); border-radius: 3px; overflow: hidden">
                    <div class="progress-bar transition-all" role="progressbar" 
                         :style="getHPBarStyle(poke)" 
                         :aria-valuenow="getHPPercent(poke)" aria-valuemin="0" aria-valuemax="100">
                    </div>
                </div>
                <small :style="{color: getHPColor(poke)}" class="font-weight-bold" style="font-size: 0.7rem; min-width: 32px; text-align: right">
                    {{ getHPPercent(poke) }}%
                </small>
            </div>

            <div class="mt-1 d-flex justify-content-between align-items-center pt-1 border-top border-dark-subtle">
              <div class="d-flex flex-wrap">
                <span v-for="(skill, index) in poke.skills" :key="index" class="badge badge-outline-secondary mr-1 mb-0 px-2 border border-secondary text-light opacity-75" style="font-size: 0.7rem; background: rgba(0,0,0,0.2)">
                  {{ skill }}
                </span>
              </div>
              <small class="text-muted font-italic opacity-50" v-if="poke.ID" style="font-size: 0.65rem">ID: {{ poke.ID }}</small>
            </div>
          </div>
        </b-col>
      </b-row>
      <div v-else class="text-center p-4">
          <b-spinner small></b-spinner>
          <span class="ml-2">Loading match details...</span>
      </div>

      <!-- Custom Context Menu -->
      <div v-if="contextMenu.show" 
           class="position-fixed border shadow-lg rounded py-1 custom-ag-menu"
           :style="{ top: contextMenu.y + 'px', left: contextMenu.x + 'px', zIndex: 9999, minWidth: '220px', backgroundColor: '#181d1f', borderColor: '#303538' }"
           @click.stop>
        <div class="px-3 py-2 custom-ag-menu-item cursor-pointer d-flex align-items-center" @click="copyMatchSummary">
          <i class="fa fa-copy mr-2 text-warning" style="width: 16px"></i> 
          <span>Copy Match Summary</span>
        </div>
        <div class="px-3 py-2 custom-ag-menu-item cursor-pointer d-flex align-items-center" @click="copyReplay">
          <i class="fa fa-clipboard mr-2 text-info" style="width: 16px"></i> 
          <span>Copy Replay Command</span>
          <small class="text-muted ml-auto font-italic" style="font-size: 0.65rem">/replay...</small>
        </div>
        <div class="dropdown-divider border-secondary my-1" style="opacity: 0.2"></div>
        <div class="px-3 py-2 custom-ag-menu-item cursor-pointer d-flex align-items-center text-muted" @click="contextMenu.show = false">
          <i class="fa fa-times mr-2" style="width: 16px"></i> Close
        </div>
      </div>
    </div>
  `,
  data() {
    return {
      match: {},
      contextMenu: {
        show: false,
        x: 0,
        y: 0
      }
    }
  },
  mounted() {
    this.match = this.params.data;
    window.addEventListener('click', this.closeContextMenu);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.closeContextMenu);
  },
  methods: {
    onContextMenu(e) {
      this.contextMenu.x = e.clientX;
      this.contextMenu.y = e.clientY;
      this.contextMenu.show = true;
    },
    closeContextMenu() {
      this.contextMenu.show = false;
    },
    copyReplay() {
      if (this.match && this.match.ID) {
          const username = this.params.context.componentParent.username;
          const command = `/replay ${this.match.ID}, ${username}`;
          navigator.clipboard.writeText(command);
          import('izitoast').then(iziToast => {
              iziToast.default.success({
                  title: 'Copied',
                  message: 'Replay command copied to clipboard',
                  position: 'topRight'
              });
          });
      }
      this.contextMenu.show = false;
    },
    copyMatchSummary() {
      if (this.match && this.match.user && this.match.opponent) {
        const formatTeam = (player) => {
          if (!player.pokemon) return "No team info";
          return Object.values(player.pokemon).map(p => {
            const hp = this.getHPPercent(p);
            return `- ${p.name} (Lvl ${p.level})${p.heldItem ? ' @ ' + p.heldItem : ''} [HP: ${hp}%]`;
          }).join('\n');
        };

        const result = this.match.isDraw ? 'DRAW' : (this.match.won ? 'WIN' : 'LOSS');
        const summary = `Match Summary: ${this.match.user.name} vs ${this.match.opponent.name}\n` +
          `Result: ${result}\n\n` +
          `${this.match.user.name}'s Team:\n${formatTeam(this.match.user)}\n\n` +
          `${this.match.opponent.name}'s Team:\n${formatTeam(this.match.opponent)}`;

        navigator.clipboard.writeText(summary);
        import('izitoast').then(iziToast => {
          iziToast.default.success({
            title: 'Copied',
            message: 'Match summary copied to clipboard',
            position: 'topRight'
          });
        });
      }
      this.contextMenu.show = false;
    },
    getHPPercent(poke) {
        const hp_after = poke.hp_after || 0;
        const hp_base = poke.hp_base || 0;
        const hp_iv = poke.hp_iv || 0;
        const hp_ev = poke.hp_ev || 0;
        const level = poke.level || 0;
        if (!hp_base || !level) return 0;
        const maxHP = Math.floor(0.01 * (2 * hp_base + hp_iv + Math.floor(0.25 * hp_ev)) * level) + level + 10;
        if (maxHP <= 0) return 0;
        return Math.min(100, Math.max(0, Math.round((hp_after / maxHP) * 100)));
    },
    getHPColor(poke) {
        const p = this.getHPPercent(poke);
        if (p > 50) return '#ffffff'; // Neutral White for healthy
        if (p > 20) return '#f1c40f'; // Yellow for damaged
        return '#e74c3c'; // Red for critical/dead
    },
    getHPBarColor(poke) {
        const p = this.getHPPercent(poke);
        if (p > 50) return '#2ecc71'; // Bar stays green for clarity
        if (p > 20) return '#f1c40f';
        return '#e74c3c';
    },
    getHPBarStyle(poke) {
        const p = this.getHPPercent(poke);
        const color = this.getHPBarColor(poke);
        if (p === 0) return { width: '0%', background: 'transparent' };
        
        return {
            width: p + '%',
            background: `linear-gradient(90deg, ${color} 0%, rgba(255,255,255,0.4) 100%)`,
            boxShadow: `0 0 4px ${color}`
        };
    },
    getCardStyle(poke) {
        const p = this.getHPPercent(poke);
        const redWidth = 100 - p;
        const alpha = 0.3; // Lowered alpha for even more subtlety
        const redColor = '80, 30, 30'; // Dark, desaturated maroon
        
        return {
            background: `linear-gradient(90deg, rgba(${redColor}, ${alpha}) ${redWidth}%, rgba(30, 30, 30, 0.9) ${redWidth}%)`,
            borderColor: `rgba(${redColor}, ${Math.min(0.6, redWidth / 100 + 0.1)}) !important`,
            opacity: p === 0 ? '0.9' : '1'
        };
    },
    refresh() {
      return false
    }
  }
})
